"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalNullable = exports.Nullable = exports.StrictObject = exports.JSONObject = exports.StringUnion = void 0;
const typebox_1 = require("@sinclair/typebox");
const primitives_1 = require("../utils/primitives");
/**
 * Create a string literal union type.
 *
 * @param values - The values to be available in the result type.
 * @param options - Optional schema options to include with the type.
 * @returns A string union type e.g. "a" | "b" | "c"
 */
function StringUnion(values, options) {
    return typebox_1.Type.Union(values.map((v) => typebox_1.Type.Literal(v)), Object.assign({ examples: values }, options));
}
exports.StringUnion = StringUnion;
/**
 * Create a non typed object which allows any properties.
 *
 * This is intended for APIs that serve JSON objects without a defined type.
 */
function JSONObject(knownProperties, options = {}) {
    return typebox_1.Type.Object(knownProperties, {
        ...options,
        additionalProperties: true,
    });
}
exports.JSONObject = JSONObject;
/**
 * Create an StrictObject  which does not allow any additional properties.
 *
 * This is essential for DTOs since we don't want additional fields being pushed into the database, etc.
 */
function StrictObject(properties, options = {}) {
    return typebox_1.Type.Object(properties, {
        ...options,
        additionalProperties: false,
    });
}
exports.StrictObject = StrictObject;
/**
 * Create a type definition that can also be null.
 *
 * @param t - The type being defined as Nullable.
 * @param options - Optional schema options to include with the type.
 * @returns A type definition for the provided type that can also be null.
 */
function Nullable(schema, options) {
    // Nulls are a bit of a mess, there is a nullable property AJV will respect on types with a single type.
    // However with types that have multiple values, we need to inject the null type as one of the options.
    if (schema.type) {
        return {
            ...schema,
            ...options,
            nullable: true,
        };
    }
    if (schema.anyOf) {
        return {
            ...schema,
            ...options,
            anyOf: [...schema.anyOf, typebox_1.Type.Null()],
        };
    }
    if (schema.oneOf) {
        return {
            ...schema,
            ...options,
            oneOf: [...schema.oneOf, typebox_1.Type.Null()],
        };
    }
    return {
        ...schema,
        ...options,
    };
}
exports.Nullable = Nullable;
/**
 * Create a type definition that can also be null or undefined.
 *
 * @param t - The type being defined as optional or Nullable.
 * @param options - Optional schema options to include with the type.
 * @returns A type definition that can also be null or optional.
 */
function OptionalNullable(schema, options) {
    const o = (0, primitives_1.mergeOptions)((0, primitives_1.extractBasicOptions)(schema), options);
    // We could combine optional and nullable together like this
    // However, this looks 'advanced' and we'll leave it to the point its required!
    // return { ...schema, nullable: true, modifier: OptionalModifier } as any;
    return typebox_1.Type.Optional(Nullable(schema, o));
}
exports.OptionalNullable = OptionalNullable;
